import { render, staticRenderFns } from "./FileDisplay.vue?vue&type=template&id=8cb61f46&scoped=true&"
import script from "./FileDisplay.vue?vue&type=script&lang=js&"
export * from "./FileDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FileDisplay.vue?vue&type=style&index=0&id=8cb61f46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb61f46",
  null
  
)

export default component.exports